import { InfoCardListProps } from "@interfaces/uiElementTypes";
import InfoCard from "./InfoCard";

const InfoCardList: React.FC<InfoCardListProps> = ({
  options,
  selectedValues,
  setSelectedValues,
  selectedValue,
  setSelectedValue,
  className,
  classNameCard,
  lookType,
  functionType,
  icons,
}) => {
  // Function for handling multiple selection
  const handleMultipleSelect = (value: string) => {
    if (selectedValues && setSelectedValues) {
      if (selectedValues.includes(value)) {
        setSelectedValues(
          selectedValues.filter((selected) => selected !== value),
        );
      } else {
        setSelectedValues([...selectedValues, value]);
      }
    }
  };

  // Function for handling single selection
  const handleSingleSelect = (value: string) => {
    if (setSelectedValue) {
      if (selectedValue === value) {
        setSelectedValue(""); // Clear the selection if the same value is clicked
      } else {
        setSelectedValue(value);
      }
    }
  };

  // Determine which function to use based on the 'functionType' prop
  const handleSelect =
    functionType != undefined && functionType === "multiple"
      ? handleMultipleSelect
      : handleSingleSelect;

  return (
    <div
      className={`grid place-content-center place-items-center ${className} ${lookType === "reservationDetails" ? "grid-cols-3 gap-x-1" : "grid-cols-2 gap-x-3 gap-y-5"}`}
    >
      {options.map((option, index) => (
        <InfoCard
          key={index}
          type={lookType}
          label={option.label}
          value={option.value}
          icon={icons[option.label] || icons["other"]}
          onClick={() => handleSelect(option.value)}
          className={classNameCard}
          selected={
            functionType === "multiple"
              ? selectedValues?.includes(option.value)
              : selectedValue === option.value
          }
        />
      ))}
    </div>
  );
};

export default InfoCardList;
